import httpService from "../../http/requests/app"

const domain = "http://localhost:10443/auth/";

export default {
    state: {

      loading: false,
      error: null
    },

    getters: {

    },
    mutations: {

    },

  actions: {
    addGroup({commit}, data) {
      return new Promise((resolve,reject) => {

        httpService.addGroup(data)
          .then(response => {

            // If there's user data in response
            if(response.data.statusCode == 200){

              resolve()

              //this.dispatch('campaigns/getCampaigns')

            }
            else{
              reject({message: response.data.message})
            }

          })
          .catch(error => { reject(error)

            //reject({message: axios.defaults.headers})
          })
      })
    },

    editGroup({commit}, data) {
      return new Promise((resolve,reject) => {

        httpService.editGroup(data)
          .then(response => {

            // If there's user data in response
            if(response.data.statusCode == 200){

              resolve()

              //this.dispatch('campaigns/getCampaigns')

            }
            else{
              reject({message: response.data.message})
            }

          })
          .catch(error => { reject(error)

            //reject({message: axios.defaults.headers})
          })
      })
    },


    deleteGroup({commit}, data) {
      return new Promise((resolve,reject) => {

        httpService.deleteGroup(data)
          .then(response => {

            // If there's user data in response
            if(response.data.statusCode == 200){

              resolve()

              //this.dispatch('campaigns/getCampaigns')

            }
            else{
              reject({message: response.data.message})
            }

          })
          .catch(error => { reject(error)

            //reject({message: axios.defaults.headers})
          })
      })
    },


    getGroups({commit}){

      return new Promise((resolve,reject) => {
        httpService.getGroups()
          .then(response => {

            resolve(response.data);

          })
          .catch(error => {
            reject(error)

            //reject({message: axios.defaults.headers})
          })
      })
    },
    changeGroupStatus({commit},data){
      return new Promise((resolve,reject) => {
        httpService.changeGroupStatus(data.status, data.group_id)
          .then(response => {

            resolve(response.data);

          })
          .catch(error => {
            reject(error)

            //reject({message: axios.defaults.headers})
          })
      })
    }



  }
};
